import { models } from '@stem-sims/great-leaps-react-common'
var recentVersion = null


function getAuth() {
    
    return models.auth.get()
    .then((auth) =>
    {
        if (!auth.user) {
            return Promise.resolve("guest")
        }
        if (recentVersion != null && auth.version != recentVersion) {
            return window.location.reload()
        }

        recentVersion = auth.version
        return Promise.resolve(auth.user)
    })
}


export default {
    "get": () =>
    {
        return getAuth()
        .catch(() => {
            return Promise.resolve("guest");
        })
    }
}
